/**
 * GmailでメールをMessage-IDで検索する（フォールバック: 件名検索）
 * @param {string} subject メールの件名
 * @param {string | null | undefined} messageId メールのMessage-ID
 * @return {void}
 */
export const searchGmail = (
  subject: string,
  messageId?: string | null,
): void => {
  const query = messageId
    ? `rfc822msgid:${encodeURIComponent(messageId)}`
    : `subject:${encodeURIComponent(subject)}`;
  window.open(
    `https://mail.google.com/mail/u/0/#search/${query}`,
    "_blank",
    "noopener,noreferrer",
  );
};
